﻿// reducers for actions used on all pages

export function pageHasErrored(state = false, action) {
    switch (action.type) {
        case 'PAGE_HAS_ERRORED':
            return action.hasErrored;
        default:
            return state;
    }
}

export function pageError(state = {}, action) {
    switch (action.type) {
        case 'PAGE_ERROR':
            return action.error;
        default:
            return state;
    }
}

export function pageIsLoading(state = true, action) {
    switch (action.type) {
        case 'PAGE_IS_LOADING':
            return action.isLoading;
        default:
            return state;
    }
}

export function pageCurrentStep(state = 0, action) {
    switch (action.type) {
        case 'PAGE_CURRENT_STEP':
            return action.step;
        default:
            return state;
    }    
}